function convertArrayToArrayWithNulls(table: any[][]): void {
  table.forEach((row) => {
    row.forEach((cell, index) => {
      if (cell === null || cell === undefined) {
        row[index] = "";
      }
    });
  });
}

function convertObjectModelToArrayWithNulls(objectModel: Record<string, any>[]): any[][] {
  if (objectModel.length === 0) return [];

  // Extract all unique keys from the array of objects
  const allKeys = new Set<string>();
  objectModel.forEach((object) => {
    Object.keys(object).forEach((key) => allKeys.add(key));
  });
  const header = Array.from(allKeys);

  // Extract the data rows, adding empty string for missing keys
  const dataRows = objectModel.map((object) => {
    return header.map((key) => {
      const value = object[key];
      if (Array.isArray(value)) {
        return `[${value.join(", ")}]`;
      }
      return value !== undefined ? value : "";
    });
  });

  // Combine the header row and data rows
  return [header, ...dataRows];
}

// Deeply flattens an object (including arrays) into dot-notated key-value pairs
function flattenObjectToKeyValueArray(object: any, prefix = ""): [string, any][] {
  let result: [string, any][] = [];
  if (Array.isArray(object)) {
    object.forEach((item, idx) => {
      const newPrefix = prefix ? `${prefix}.${idx}` : `${idx}`;
      result = result.concat(flattenObjectToKeyValueArray(item, newPrefix));
    });
  } else if (object !== null && typeof object === "object") {
    Object.entries(object).forEach(([key, value]) => {
      const newPrefix = prefix ? `${prefix}.${key}` : key;
      result = result.concat(flattenObjectToKeyValueArray(value, newPrefix));
    });
  } else {
    result.push([prefix, object]);
  }
  return result;
}

export function tableConverter(data: any): any[][] {
  // Ensure data is an array
  if (!Array.isArray(data)) {
    data = [data];
  }

  // Process the data into a table format
  let table: any[][];
  if (Array.isArray(data) && data.length !== 0 && data.every((item) => Array.isArray(item))) {
    table = convertObjectModelToArrayWithNulls(data);
  } else {
    table = data.flatMap((item: any) => flattenObjectToKeyValueArray(item));
  }

  convertArrayToArrayWithNulls(table);

  return table;
}
